document.addEventListener('DOMContentLoaded', function () {
    const dropdowns = document.querySelectorAll('.has-dropdown')
    const globalOverlay = document.querySelector('.global-overlay')
    const mobileButton = document.querySelector('.mobile-button button')
    const menuContainer = document.querySelector('.menu-container')
    const body = document.body

    function addHoverListeners(dropdown) {
        let closeTimeout

        dropdown.addEventListener('mouseenter', function () {
            clearTimeout(closeTimeout)

            dropdown.classList.add('open')
            globalOverlay.classList.add('show')
        })

        dropdown.addEventListener('mouseleave', function () {
            closeTimeout = setTimeout(function () {
                dropdown.classList.remove('open')

                checkOverlayState()
            }, 200)
        })
    }

    function removeHoverListeners(dropdown) {
        dropdown.removeEventListener('mouseenter', function () {
            dropdown.classList.add('open')
            globalOverlay.classList.add('show')
        })

        dropdown.removeEventListener('mouseleave', function () {
            dropdown.classList.remove('open')
            checkOverlayState()
        })
    }

    function checkWindowWidth() {
        dropdowns.forEach(function (dropdown) {
            const button = dropdown.querySelector('button')

            // Remove existing listeners to avoid duplication
            dropdown.classList.remove('open')
            button.removeEventListener('click', toggleDropdown)

            if (window.innerWidth > 1024) {
                addHoverListeners(dropdown)
            } else {
                removeHoverListeners(dropdown)

                // Toggle dropdown on button click
                button.addEventListener('click', toggleDropdown)
            }
        })
    }

    function toggleDropdown(event) {
        event.stopPropagation()
        const dropdown = event.currentTarget.closest('.has-dropdown')
        dropdown.classList.toggle('open')
        checkOverlayState()
    }

    function toggleMenu() {
        menuContainer.classList.toggle('open')
        mobileButton.classList.toggle('active')

        // Add or remove "overflow: hidden" on the body when the menu is toggled
        if (menuContainer.classList.contains('open')) {
            body.style.overflow = 'hidden'
        } else {
            body.style.overflow = ''
        }

        checkOverlayState()
    }

    function checkOverlayState() {
        const isAnyDropdownOpen = Array.from(dropdowns).some((dropdown) => dropdown.classList.contains('open'))
        const isMenuOpen = menuContainer.classList.contains('open')

        if (isAnyDropdownOpen || isMenuOpen) {
            globalOverlay.classList.add('show')
        } else {
            globalOverlay.classList.remove('show')
        }
    }

    // Close dropdowns and menu when clicking outside
    document.addEventListener('click', function (event) {
        dropdowns.forEach(function (dropdown) {
            if (!dropdown.contains(event.target) && !mobileButton.contains(event.target)) {
                dropdown.classList.remove('open')
            }
        })

        if (!menuContainer.contains(event.target) && !mobileButton.contains(event.target)) {
            menuContainer.classList.remove('open')
            mobileButton.classList.remove('active')
            body.style.overflow = ''
        }

        checkOverlayState()
    })

    // Toggle menu on mobile button click
    mobileButton.addEventListener('click', function (event) {
        event.stopPropagation()
        toggleMenu()
    })

    // Initial check and add listeners
    checkWindowWidth()

    // Listen to window resize and adjust accordingly
    window.addEventListener('resize', checkWindowWidth)
})
